<app-base-modal [isOpen]="isOpen" (close)="onClose()">
  <h1 header>Attention!</h1>

  <div class="delete-cover-page-modal">
    <p class="delete-cover-page-modal__body">
      You are deleting cover page

      <span class="delete-cover-page-modal__subject">
        {{ coverPageTitle }}
      </span>
    </p>

    <p class="delete-cover-page-modal__question">Are you sure?</p>

    <div class="delete-cover-page-modal__actions">
      <button class="btn_secondary btn_lg" (click)="onClose()">No</button>
      <button class="btn_primary btn_lg" (click)="onSubmit()">Yes</button>
    </div>
  </div>
</app-base-modal>
